/* ==========================================================================
   Daftar Dept. PDP 2026
   Vanilla, no dependencies. Every component is isolated and guards its own
   DOM, so a missing section never breaks the rest of the page.
   ========================================================================== */
(function () {
  "use strict";

  /* This file is requested by more than one PDP section (the buy box, the size
     guide, the cross sell rail). Identical <script src> tags are NOT deduped by
     the browser -- each one executes -- so two copies of this module used to
     attach two click listeners to the same quick add rail. The trigger toggle
     then fired twice per click and cancelled itself, which is why "Add" in the
     upsell did nothing. Run the module once per page. */
  if (window.__ddPdp2026) return;
  window.__ddPdp2026 = true;

  /* Mirrors Shopify's money filter so a JS-rendered price is byte-identical
     to the one Liquid rendered on load. Anything less and the price visibly
     reformats the moment a size is picked. */
  var TOKEN = /\{\{\s*(\w+)\s*\}\}/;

  function group(cents, thousands, decimalSep, precision) {
    var fixed = (Number(cents) / 100).toFixed(precision);
    var parts = fixed.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimalSep + parts[1] : whole;
  }

  var money = function (cents, format) {
    var fmt = format || "{{amount}}";
    var match = fmt.match(TOKEN);
    var token = match ? match[1] : "amount";
    var value;

    switch (token) {
      case "amount_no_decimals":
        value = group(cents, ",", ".", 0); break;
      case "amount_with_comma_separator":
        value = group(cents, ".", ",", 2); break;
      case "amount_no_decimals_with_comma_separator":
        value = group(cents, ".", ",", 0); break;
      case "amount_with_space_separator":
        value = group(cents, " ", ",", 2); break;
      case "amount_no_decimals_with_space_separator":
        value = group(cents, " ", ",", 0); break;
      case "amount_with_apostrophe_separator":
        value = group(cents, "'", ".", 2); break;
      default:
        value = group(cents, ",", ".", 2);
    }
    return fmt.replace(TOKEN, value);
  };

  var cartRoutes = function () {
    return (window.routes && window.routes.cart_add_url) || "/cart/add";
  };

  /* The single authority on which urgency rows are visible.
     Each row marks itself data-eligible="1" or "0"; this picks the highest
     priority few and shows only those. Six competing alarms read as
     desperation and cost more trust than the scarcity buys. */
  function capUrgency(urgencyRoot) {
    if (!urgencyRoot) return;
    var max = parseInt(urgencyRoot.dataset.maxVisible, 10) || 3;
    var items = Array.prototype.slice.call(urgencyRoot.children).filter(function (el) {
      return el.hasAttribute("data-priority");
    });
    var eligible = items.filter(function (el) { return el.dataset.eligible !== "0"; });
    eligible.sort(function (a, b) {
      return (parseInt(a.dataset.priority, 10) || 99) - (parseInt(b.dataset.priority, 10) || 99);
    });
    items.forEach(function (el) { el.classList.remove("show"); });
    eligible.slice(0, max).forEach(function (el) { el.classList.add("show"); });
  }

  /* ----------------------------------------------------------------------
     Cart: mirrors the theme's own add-to-cart so the existing minicart
     drawer, cart count, header total and free-shipping bar all stay in sync.
     ---------------------------------------------------------------------- */
  function addToCart(items, button) {
    var drawer =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    var formData = new FormData();
    items.forEach(function (item, i) {
      formData.append("items[" + i + "][id]", item.id);
      formData.append("items[" + i + "][quantity]", item.quantity || 1);
    });

    if (drawer && typeof drawer.getSectionsToRender === "function") {
      formData.append(
        "sections",
        drawer.getSectionsToRender().map(function (s) { return s.id; })
      );
      formData.append("sections_url", window.location.pathname);
    }

    if (button) button.classList.add("is-loading");

    return fetch(cartRoutes() + ".js", {
      method: "POST",
      headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: formData
    })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var state;
        try { state = JSON.parse(text); } catch (e) { state = {}; }

        if (state.status && state.description) {
          throw new Error(state.description);
        }

        // Refresh counters from the source of truth.
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll(".cart-count").forEach(function (el) {
              if (el.classList.contains("cart-count-drawer")) {
                el.innerHTML = "(" + cart.item_count + ")";
              } else {
                el.innerHTML = cart.item_count;
              }
            });
            var total = document.querySelector("header-total-price");
            if (total && typeof total.updateTotal === "function") total.updateTotal(cart);
            var ship = document.querySelector("free-ship-progress-bar");
            if (ship && typeof ship.init === "function") ship.init(cart.items_subtotal_price);
          })
          .catch(function () { /* counters are cosmetic, never block the add */ });

        // Re-render the minicart markup the theme expects.
        if (drawer && state.sections && typeof drawer.getSectionsToRender === "function") {
          drawer.getSectionsToRender().forEach(function (section) {
            var el = document.getElementById(section.id);
            if (!el || !state.sections[section.id]) return;
            var html = new DOMParser().parseFromString(state.sections[section.id], "text/html");
            var form = html.querySelector("#form-mini-cart");
            if (form) el.innerHTML = form.innerHTML;
          });
          if (typeof drawer.cartAction === "function") drawer.cartAction();
        }

        if (drawer && typeof drawer.open === "function") {
          drawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        }
        if (window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === "function") {
          window.BlsLazyloadImg.init();
        }
      })
      .catch(function (err) {
        console.error("[pdp-2026] add to cart failed", err);
        alert(err && err.message ? err.message : "Could not add this to your bag. Please try again.");
      })
      .finally(function () {
        if (button) button.classList.remove("is-loading");
      });
  }

  /* ----------------------------------------------------------------------
     Buy box: colour + size selection, variant resolution, ATC guard.
     ---------------------------------------------------------------------- */
  function initBuyBox(root) {
    /* Read the variant data the theme's <variant-selects> already ships
       rather than printing a second copy of it. Shopify's product.variants
       json carries everything needed, under its own field names. */
    var dataEl = root.querySelector(
      "variant-selects script[type='application/json']:not(.productVariantsQty)"
    );
    if (!dataEl) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent).map(function (v) {
        return {
          id: v.id,
          options: v.options,
          available: v.available,
          price: v.price,
          compare_at_price: v.compare_at_price || 0,
          inventory: v.inventory_quantity,
          tracked: !!v.inventory_management,
          /* Shopify's canonical variant-to-image link, and the same one the
             theme's own updateMedia() follows. Null until someone assigns an
             image to the variant in the admin. */
          mediaId: v.featured_media ? v.featured_media.id : null
        };
      });
    } catch (e) { return; }

    var sizeIndex = parseInt(root.dataset.sizeIndex, 10);
    var colourIndex = parseInt(root.dataset.colourIndex, 10);
    var hasSize = !isNaN(sizeIndex) && sizeIndex >= 0;

    var idInput = root.querySelector("[data-pdp-variant-id]");
    var priceEl = root.querySelector("[data-pdp-price]");
    var mrpEl = root.querySelector("[data-pdp-mrp]");
    var saveEl = root.querySelector("[data-pdp-save]");
    var ctaPrice = root.querySelector("[data-pdp-cta-price]");
    var mainCta = root.querySelector("[data-pdp-atc]");
    var moneyFormat = root.dataset.moneyFormat || "Rs {{amount}}";

    /* Read straight off whichever variant the theme has selected. */
    function selectedSize() {
      var v = currentVariant();
      return v && hasSize ? v.options[sizeIndex] : null;
    }
    function selectedColour() {
      var v = currentVariant();
      return v && !isNaN(colourIndex) && colourIndex >= 0 ? v.options[colourIndex] : null;
    }

    function renderPrice(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price, moneyFormat);
      if (ctaPrice) ctaPrice.textContent = money(v.price, moneyFormat);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (mrpEl) {
        mrpEl.textContent = onSale ? money(v.compare_at_price, moneyFormat) : "";
        mrpEl.hidden = !onSale;
      }
      if (saveEl) {
        if (onSale) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          saveEl.textContent = pct + "% off";
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function syncSticky() {
      var bar = document.querySelector("[data-pdp-sticky]");
      if (!bar) return;
      var meta = bar.querySelector("[data-pdp-sticky-meta]");
      if (!meta) return;
      var v = currentVariant();
      var priceText = v ? money(v.price, moneyFormat) : meta.dataset.basePrice || "";
      var size = selectedSize();
      meta.textContent = hasSize
        ? priceText + " · " + (size ? "Size " + size : meta.dataset.selectLabel || "Select size")
        : priceText;
    }

    /* Low stock bar. Shows only for a variant whose inventory is actually
       tracked and genuinely low, so it can never display an invented number.
       Untracked variants report 0 from Liquid, which would otherwise read as
       "sold out" here. */
    var stockEl = root.querySelector("[data-pdp-stock]");
    function renderStock(v) {
      if (!stockEl) return;
      var threshold = parseInt(stockEl.dataset.threshold, 10) || 10;
      var scale = parseInt(stockEl.dataset.scale, 10) || 20;
      var show = v && v.tracked && v.inventory > 0 && v.inventory <= threshold;

      stockEl.dataset.eligible = show ? "1" : "0";
      if (!show) return;

      var textEl = stockEl.querySelector("[data-pdp-stock-text]");
      var fillEl = stockEl.querySelector("[data-pdp-stock-fill]");
      if (textEl) {
        textEl.textContent = (stockEl.dataset.template || "Only {count} left")
          .replace("{count}", v.inventory);
      }
      if (fillEl) {
        fillEl.style.width = Math.max(4, Math.min(100, (v.inventory / scale) * 100)) + "%";
      }
    }

    /* --- sizes already sold out, for the colour currently chosen --- */
    var sizesGoneEl = root.querySelector("[data-pdp-sizes-gone]");
    function renderSizesGone() {
      if (!sizesGoneEl || !hasSize) return;
      var all = [], gone = [];
      variants.forEach(function (v) {
        var size = v.options[sizeIndex];
        if (all.indexOf(size) === -1) all.push(size);
      });
      var colour = selectedColour();
      all.forEach(function (size) {
        var any = variants.some(function (v) {
          if (v.options[sizeIndex] !== size || !v.available) return false;
          if (!colour) return true;
          return v.options[colourIndex] === colour;
        });
        if (!any) gone.push(size);
      });

      // Only interesting when some are gone but the product is still buyable.
      var show = gone.length > 0 && gone.length < all.length;
      sizesGoneEl.dataset.eligible = show ? "1" : "0";
      if (!show) return;

      var textEl = sizesGoneEl.querySelector("[data-pdp-sizes-gone-text]");
      if (textEl) {
        textEl.textContent = (sizesGoneEl.dataset.template || "{gone} of {total} sizes already gone: {names}")
          .replace("{gone}", gone.length)
          .replace("{total}", all.length)
          .replace("{names}", gone.join(", "));
      }
    }

    /* --- how many of the chosen variant are already in the bag --- */
    var inCartEl = root.querySelector("[data-pdp-in-cart]");
    var cartMap = {};
    var cartEl = root.querySelector("[data-pdp-cart]");
    if (cartEl) {
      try { cartMap = JSON.parse(cartEl.textContent); } catch (e) { cartMap = {}; }
    }
    function renderInCart(v) {
      if (!inCartEl) return;
      var qty = v ? cartMap[String(v.id)] : 0;
      var show = !!qty && qty > 0;
      inCartEl.dataset.eligible = show ? "1" : "0";
      if (!show) return;
      var textEl = inCartEl.querySelector("[data-pdp-in-cart-text]");
      if (textEl) {
        textEl.textContent = (inCartEl.dataset.template || "You already have {count} of this in your bag")
          .replace("{count}", qty);
      }
    }

    var urgencyRoot = root.querySelector("[data-pdp-urgency]");
    function applyUrgencyCap() { capUrgency(urgencyRoot); }

    function update() {
      var v = currentVariant();
      var gal = document.querySelector("[data-pdp-gallery]");
      if (gal && gal._pdpSyncVariant) {
        gal._pdpSyncVariant({ colour: selectedColour(), mediaId: v ? v.mediaId : null });
      }
      renderPrice(v);
      renderStock(v);
      renderSizesGone();
      renderInCart(v);
      applyUrgencyCap();
      syncSticky();

    }

    /* --- follow the theme's variant selector ---
       The theme's <variant-selects> element owns option clicks, variant
       resolution, price, availability, media and the URL. We do not bind to
       the swatches at all. It writes the chosen id into input[name="id"] and
       dispatches a bubbling "change" on it, so that input is our single
       source of truth for the supplementary UI on this page. */
    function currentVariant() {
      if (!idInput) return null;
      var id = String(idInput.value);
      return variants.find(function (v) { return String(v.id) === id; }) || null;
    }

    if (idInput) {
      idInput.addEventListener("change", update);
    }

    /* The sticky bar sits outside the form, so it asks the form to submit and
       the theme's product-form handler takes it from there. */
    var pdpForm = document.getElementById(root.dataset.formId || "") ||
                  root.querySelector("form[action*='/cart/add']");
    document.querySelectorAll("[data-pdp-atc-sticky]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!pdpForm) return;
        if (typeof pdpForm.requestSubmit === "function") {
          pdpForm.requestSubmit();
        } else {
          var submit = pdpForm.querySelector('[type="submit"]');
          if (submit) submit.click();
        }
      });
    });


    update();

    /* --- sticky bar visibility --- */
    var bar = document.querySelector("[data-pdp-sticky]");
    if (bar && mainCta && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            bar.classList.toggle("on", !en.isIntersecting);
          });
        },
        { rootMargin: "0px 0px -40px 0px" }
      );
      io.observe(mainCta);
    }
  }

  /* ----------------------------------------------------------------------
     Dispatch cutoff countdown.
     Counts down to a real daily cutoff expressed in the STORE's timezone, not
     the viewer's, so every buyer sees the same deadline and it genuinely
     expires rather than restarting on reload. After the cutoff it swaps to an
     honest "dispatched tomorrow" line instead of resetting the clock.
     ---------------------------------------------------------------------- */
  function initCutoff(el) {
    var hour = parseInt(el.dataset.hour, 10);
    var minute = parseInt(el.dataset.minute, 10) || 0;
    var offset = parseFloat(el.dataset.offset);
    var before = el.dataset.before || "Order within {time} for dispatch today";
    var after = el.dataset.after || "Dispatched tomorrow";
    var textEl = el.querySelector("[data-pdp-cutoff-text]");
    if (isNaN(hour) || isNaN(offset) || !textEl) return;

    function storeNow() {
      var now = new Date();
      // Shift real UTC into the store's wall clock.
      return new Date(now.getTime() + now.getTimezoneOffset() * 60000 + offset * 3600000);
    }

    function tick() {
      var nowZ = storeNow();
      var target = new Date(nowZ);
      target.setHours(hour, minute, 0, 0);
      var ms = target - nowZ;

      if (ms <= 0) {
        textEl.textContent = after;
        el.dataset.eligible = "1";
        capUrgency(el.closest("[data-pdp-urgency]"));
        return;
      }

      writeCountdown(textEl, before, ms);
      el.dataset.eligible = "1";
      capUrgency(el.closest("[data-pdp-urgency]"));
    }

    tick();
    setInterval(tick, 30000);
  }

  /* Writes "…{time}…" with the clock portion in its own span so it can carry
     tabular figures and not jitter as the digits change. */
  function writeCountdown(textEl, template, ms) {
    var totalMin = Math.floor(ms / 60000);
    var d = Math.floor(totalMin / 1440);
    var h = Math.floor((totalMin % 1440) / 60);
    var m = totalMin % 60;
    var label = d > 0 ? d + "d " + h + "h" : h > 0 ? h + "h " + m + "m" : m + "m";

    var parts = String(template).split("{time}");
    textEl.textContent = "";
    textEl.appendChild(document.createTextNode(parts[0] || ""));
    var clock = document.createElement("span");
    clock.className = "clock";
    clock.textContent = label;
    textEl.appendChild(clock);
    if (parts[1]) textEl.appendChild(document.createTextNode(parts[1]));
  }

  /* ----------------------------------------------------------------------
     Offer countdown. Reads a real end datetime from a metafield. When that
     moment passes the row removes itself for good rather than looping, so it
     can never become a permanent fake deadline.
     ---------------------------------------------------------------------- */
  function initOffer(el) {
    var textEl = el.querySelector("[data-pdp-offer-text]");
    var ends = Date.parse(el.dataset.ends);
    if (!textEl || isNaN(ends)) return;

    function tick() {
      var ms = ends - Date.now();
      if (ms <= 0) {
        el.dataset.eligible = "0";
        capUrgency(el.closest("[data-pdp-urgency]"));
        return;
      }
      writeCountdown(textEl, el.dataset.template || "This price ends in {time}", ms);
      el.dataset.eligible = "1";
      capUrgency(el.closest("[data-pdp-urgency]"));
    }

    tick();
    setInterval(tick, 30000);
  }

  /* ----------------------------------------------------------------------
     Coupon codes: tap to copy.
     The async clipboard API needs a secure context, which a custom domain has
     but a plain-http preview may not, so there is a textarea fallback.
     ---------------------------------------------------------------------- */
  function initCoupons() {
    document.querySelectorAll("[data-pdp-coupon]").forEach(function (btn) {
      if (!once(btn, "Coupon")) return;
      var action = btn.querySelector(".pdp-coupon-action");
      var original = action ? action.textContent : "";
      var timer = null;

      function confirmCopied() {
        btn.classList.add("is-copied");
        if (action) action.textContent = btn.dataset.copied || "Copied";
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove("is-copied");
          if (action) action.textContent = original;
        }, 2000);
      }

      function fallback(text) {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.cssText = "position:fixed;top:-1000px;opacity:0";
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand("copy"); } catch (e) { /* nothing else to try */ }
        document.body.removeChild(ta);
      }

      btn.addEventListener("click", function () {
        var code = btn.dataset.code || "";
        if (!code) return;
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(confirmCopied, function () {
            fallback(code);
            confirmCopied();
          });
        } else {
          fallback(code);
          confirmCopied();
        }
      });
    });
  }

  /* ----------------------------------------------------------------------
     Size guide popup. Opened from the buy box link; the content lives in its
     own section so it stays editable in the theme editor.
     ---------------------------------------------------------------------- */
  function initSizeGuide() {
    var modal = document.querySelector("[data-pdp-sizeguide]");
    var openers = document.querySelectorAll("[data-pdp-sizeguide-open]");
    if (!modal || !openers.length) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = "hidden";
      var panel = modal.querySelector(".pdp-modal-panel");
      if (panel) { panel.setAttribute("tabindex", "-1"); panel.focus(); }
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Openers live in the buy box and the modal in its own section, so the two
       are guarded separately: either can re-render without the other. */
    openers.forEach(function (b) {
      if (once(b, "SgOpen")) b.addEventListener("click", open);
    });
    modal.querySelectorAll("[data-pdp-sizeguide-close]").forEach(function (b) {
      if (once(b, "SgClose")) b.addEventListener("click", close);
    });
    if (once(modal, "SgKeys")) {
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) close();
      });
    }
  }

  /* ----------------------------------------------------------------------
     Gallery dots
     ---------------------------------------------------------------------- */
  function initGallery(root) {
    var mediaEl = root.querySelector("[data-pdp-media]");
    var media = [];
    try { media = JSON.parse(mediaEl.textContent); } catch (e) { media = []; }
    var pswpItems = media.map(function (m) {
      return { src: m.src, width: m.w, height: m.h, alt: m.alt };
    });
    /* Maps a slide's DOM index to its position in the (possibly filtered)
       lightbox set, so opening image 9 of 17 lands on the right frame. */
    var lightboxIndexOf = function (i) { return i; };

    /* One element serves as both the mobile rail and the desktop stage. */
    var viewport = root.querySelector("[data-pdp-viewport]");
    var dots = root.querySelectorAll("[data-pdp-dots] i");
    var thumbs = root.querySelectorAll("[data-pdp-thumbs] .pdp-thumb");
    var slides = viewport ? viewport.querySelectorAll(".pdp-slide") : [];

    /* Reassigned by applyColour() whenever a colour narrows the set. Every
       navigation helper asks this rather than assuming all slides are on
       screen, which is what used to put the dots out of step with the rail. */
    var visibleAt = function () { return true; };

    function setActive(i) {
      if (!slides.length || i < 0 || i >= slides.length) return;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle("is-active", k === i);
        t.setAttribute("aria-selected", k === i ? "true" : "false");
      });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }

    /* The same element is a snap rail on mobile and a one-up stage on desktop.
       Scrolling is only meaningful in the first case. */
    function scrollRailTo(i) {
      if (!viewport || !slides[i]) return;
      if (viewport.scrollWidth <= viewport.clientWidth + 1) return;
      viewport.scrollTo({
        left: slides[i].offsetLeft - viewport.offsetLeft,
        behavior: "smooth"
      });
    }

    function goTo(i) {
      if (!slides.length) return;
      if (i < 0 || i >= slides.length || !visibleAt(i)) {
        i = -1;
        for (var k = 0; k < slides.length; k++) {
          if (visibleAt(k)) { i = k; break; }
        }
        if (i < 0) return;
      }
      setActive(i);
      scrollRailTo(i);
    }

    function indexOfMedia(id) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(id)) return i;
      }
      return -1;
    }

    /* --- thumbnails drive the stage --- */
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        goTo(parseInt(t.dataset.index, 10) || 0);
      });
    });

    /* --- open the lightbox --- */
    function open(i) {
      if (window.pdpOpenLightbox && pswpItems.length) window.pdpOpenLightbox(pswpItems, lightboxIndexOf(i));
    }
    function bindOpen(container) {
      if (!container) return;
      container.addEventListener("click", function (e) {
        // never hijack a click on video controls
        if (e.target.closest("video")) return;
        var slide = e.target.closest(".pdp-slide");
        if (!slide) return;
        open(parseInt(slide.dataset.index, 10) || 0);
      });
    }
    bindOpen(viewport);

    /* --- mobile rail dots --- */
    if (viewport && dots.length) {
      viewport.addEventListener("scroll", function () {
        /* Measure against the slides themselves. Dividing the scroll width by
           the child count assumed every slide was on screen and equally wide,
           so one hidden slide put every dot off by one. */
        var x = viewport.scrollLeft;
        var best = -1;
        var bestDist = Infinity;
        slides.forEach(function (s, k) {
          if (!visibleAt(k)) return;
          var d = Math.abs((s.offsetLeft - viewport.offsetLeft) - x);
          if (d < bestDist) { bestDist = d; best = k; }
        });
        if (best >= 0) setActive(best);
      }, { passive: true });
    }

    /* The viewport already advertises itself as a focusable region, so it
       should answer the arrow keys. */
    if (viewport) {
      viewport.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        var cur = -1;
        slides.forEach(function (s, k) { if (s.classList.contains("is-active")) cur = k; });
        var step = e.key === "ArrowRight" ? 1 : -1;
        for (var k = cur + step; k >= 0 && k < slides.length; k += step) {
          if (visibleAt(k)) { e.preventDefault(); goTo(k); return; }
        }
      });
    }

    /* --- variant to gallery ---
       Two links, strongest first, matching what the theme itself does:

       1. variant.featured_media - the image a merchant attached to that exact
          variant in the admin. Unambiguous, so it always wins. This is the
          link the theme's own updateMedia() follows.
       2. Colour grouping by alt text - the theme's fallback, where every photo
          of the black tee carries "Black" as its alt. Narrows the gallery to
          the photos for the chosen colour.

       Neither can invent data. A product with one photo, no variant images and
       the product title as its alt has nothing to switch to, and the gallery
       correctly holds still. */

    function norm(v) { return String(v || "").trim().toLowerCase(); }

    /* Exact alt match is what the theme documents. The word test is a second
       pass for alts like "Black / front", and only runs when exact matching
       finds nothing, so it can never override a clean match. */
    function altMatches(alt, want, loose) {
      var a = norm(alt);
      if (!a || !want) return false;
      if (a === want) return true;
      if (!loose) return false;
      /* Word-boundary containment done by hand, so nothing has to be escaped
         into a regex: "black / front" contains "black" flanked by
         non-alphanumerics, while "blackberry" does not. */
      var at = a.indexOf(want);
      while (at > -1) {
        var before = at === 0 ? "" : a.charAt(at - 1);
        var after = a.charAt(at + want.length);
        if (!/[a-z0-9]/.test(before) && !/[a-z0-9]/.test(after)) return true;
        at = a.indexOf(want, at + 1);
      }
      return false;
    }

    function matchesFor(want) {
      var hit = [];
      slides.forEach(function (s, i) {
        if (altMatches(s.dataset.alt, want, false)) hit.push(i);
      });
      if (hit.length) return hit;
      slides.forEach(function (s, i) {
        if (altMatches(s.dataset.alt, want, true)) hit.push(i);
      });
      return hit;
    }

    function applyColour(colour) {
      var want = norm(colour);
      var matched = want ? matchesFor(want) : [];
      /* A colour with no photos of its own shows the whole set rather than an
         empty gallery. */
      var show = matched.length ? matched : null;

      visibleAt = function (i) { return !show || show.indexOf(i) !== -1; };

      slides.forEach(function (s, i) { s.dataset.hidden = visibleAt(i) ? "0" : "1"; });
      thumbs.forEach(function (t, i) { t.hidden = !visibleAt(i); });
      dots.forEach(function (d, i) { d.hidden = !visibleAt(i); });

      // rebuild the lightbox set so its order matches what is on screen
      pswpItems = media
        .filter(function (m, i) { return visibleAt(i); })
        .map(function (m) { return { src: m.src, width: m.w, height: m.h, alt: m.alt }; });
      lightboxIndexOf = function (domIndex) {
        var n = 0;
        for (var i = 0; i < media.length; i++) {
          if (!visibleAt(i)) continue;
          if (i === domIndex) return n;
          n++;
        }
        return 0;
      };

      goTo(show ? show[0] : 0);
    }

    var lastColour = null;
    var syncedOnce = false;

    root._pdpSyncVariant = function (opts) {
      var colour = opts && opts.colour != null ? opts.colour : null;
      var mediaId = opts && opts.mediaId != null ? opts.mediaId : null;

      /* Re-grouping on every variant change was snapping the gallery back to
         the first photo whenever the shopper only changed size. Regroup when
         the colour actually moves, and once on the first call. */
      if (!syncedOnce || norm(colour) !== norm(lastColour)) {
        syncedOnce = true;
        lastColour = colour;
        applyColour(colour);
      }

      if (mediaId != null) {
        var i = indexOfMedia(mediaId);
        if (i > -1) {
          /* The merchant pinned this image to this variant, so trust it over
             the alt grouping and widen the set if the filter had hidden it. */
          if (!visibleAt(i)) { lastColour = null; applyColour(null); }
          goTo(i);
        }
      }
    };

    /* Older name, kept so anything still calling it keeps working. */
    root._pdpFilterColour = function (colour) {
      root._pdpSyncVariant({ colour: colour });
    };
  }

  /* ----------------------------------------------------------------------
     Pincode checker. Reassurance only, never a gate on add to cart.
     ---------------------------------------------------------------------- */
  function initPincode(root) {
    var input = root.querySelector("[data-pdp-pin-input]");
    var btn = root.querySelector("[data-pdp-pin-btn]");
    var out = root.querySelector("[data-pdp-pin-out]");
    if (!input || !btn || !out) return;

    try {
      var saved = localStorage.getItem("dd_pincode");
      if (saved) input.value = saved;
    } catch (e) { /* private mode */ }

    input.addEventListener("input", function () {
      input.value = input.value.replace(/\D/g, "").slice(0, 6);
    });

    btn.addEventListener("click", function () {
      var v = input.value.trim();
      out.classList.remove("ok", "bad");
      if (v.length !== 6) {
        out.textContent = out.dataset.invalid || "Enter a valid 6 digit pincode.";
        out.classList.add("show", "bad");
        return;
      }
      try { localStorage.setItem("dd_pincode", v); } catch (e) { /* ignore */ }

      // No shipping API is wired yet, so we show the honest generic range.
      // Swap this block for the real serviceability call when it exists.
      var days = parseInt(root.dataset.etaMin || "2", 10);
      var maxDays = parseInt(root.dataset.etaMax || "5", 10);
      var d1 = new Date(); d1.setDate(d1.getDate() + days);
      var d2 = new Date(); d2.setDate(d2.getDate() + maxDays);
      var fmt = function (d) {
        return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
      };
      out.textContent = (out.dataset.okPrefix || "Arriving between") + " " + fmt(d1) + " and " + fmt(d2) + ".";
      out.classList.add("show", "ok");
    });
  }

  /* ----------------------------------------------------------------------
     Cross sell quick add: reveals an inline size picker, then adds.
     ---------------------------------------------------------------------- */
  function initQuickAdd(root) {
    /* The panel is a sibling of the row the button sits in, not a child of the
       button's parent, so resolve it from the enclosing card. */
    function panelFor(el) {
      var card = el.closest(".pdp-upsell-tile, .pdp-xs-card");
      return card ? card.querySelector("[data-pdp-qa]") : el.parentElement.querySelector("[data-pdp-qa]");
    }

    root.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-pdp-qa-trigger]");
      if (trigger) {
        var panel = panelFor(trigger);
        if (!panel) return;
        var open = !panel.classList.contains("show");
        // one open picker at a time keeps the list compact
        root.querySelectorAll("[data-pdp-qa].show").forEach(function (p) {
          p.classList.remove("show");
        });
        root.querySelectorAll('[data-pdp-qa-trigger][aria-expanded="true"]').forEach(function (b) {
          b.setAttribute("aria-expanded", "false");
        });
        panel.classList.toggle("show", open);
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
        return;
      }

      /* Option picker: one row per option, resolve to a variant, then add. */
      var val = e.target.closest("[data-qa-value]");
      if (val) {
        var optRow = val.closest("[data-qa-opt]");
        optRow.querySelectorAll("[data-qa-value]").forEach(function (b) {
          b.classList.toggle("is-on", b === val);
        });
        syncPicker(panelFor(val));
        return;
      }

      var confirm = e.target.closest("[data-pdp-qa-confirm]");
      if (confirm && !confirm.disabled) {
        var id = confirm.dataset.variantId;
        if (!id) return;
        addToCart([{ id: id, quantity: 1 }], confirm).then(function () { closePanel(confirm); });
        return;
      }

      /* Single variant products, and the cross-sell rail, add in one tap. */
      var pick = e.target.closest("[data-pdp-qa-variant]");
      if (pick && !pick.disabled) {
        addToCart([{ id: pick.dataset.pdpQaVariant, quantity: 1 }], pick).then(function () {
          closePanel(pick);
        });
      }
    });

    function closePanel(el) {
      var panel = panelFor(el);
      if (panel) panel.classList.remove("show");
      var card = el.closest(".pdp-upsell-tile, .pdp-xs-card");
      var btn = card && card.querySelector("[data-pdp-qa-trigger]");
      if (btn) btn.setAttribute("aria-expanded", "false");
    }

    /* Marks unreachable option values, resolves the variant, and updates the
       confirm button. Mirrors how the main buy box narrows availability. */
    function syncPicker(panel) {
      if (!panel) return;
      var dataEl = panel.querySelector("[data-pdp-qa-variants]");
      var confirmBtn = panel.querySelector("[data-pdp-qa-confirm]");
      var hint = panel.querySelector("[data-pdp-qa-hint]");
      if (!dataEl || !confirmBtn) return;

      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var rows = Array.prototype.slice.call(panel.querySelectorAll("[data-qa-opt]"));
      var chosen = rows.map(function (r) {
        var on = r.querySelector("[data-qa-value].is-on");
        return on ? on.dataset.qaValue : null;
      });

      // grey out values that cannot combine with what is already picked
      rows.forEach(function (row, i) {
        row.querySelectorAll("[data-qa-value]").forEach(function (b) {
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            if (v.options[i] !== b.dataset.qaValue) return false;
            return chosen.every(function (c, j) { return j === i || !c || v.options[j] === c; });
          });
          b.disabled = !ok;
        });
      });

      var complete = chosen.every(function (c) { return !!c; });
      var match = complete && variants.find(function (v) {
        return v.available && chosen.every(function (c, j) { return v.options[j] === c; });
      });

      confirmBtn.disabled = !match;
      confirmBtn.dataset.variantId = match ? match.id : "";
      if (hint) {
        hint.textContent = match
          ? (confirmBtn.dataset.addLabel || "Add to bag")
          : (confirmBtn.dataset.chooseLabel || hint.textContent);
      }
    }
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */

  /* boot() runs again on every shopify:section:load, and most nodes survive a
     neighbouring section's re-render. Marking each node keeps every listener
     bound exactly once, whatever order sections load in. */
  function once(el, key) {
    if (!el) return false;
    var flag = "ddi" + key;
    if (el.dataset[flag] === "1") return false;
    el.dataset[flag] = "1";
    return true;
  }

  function each(selector, key, fn) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (once(el, key)) fn(el);
    });
  }

  function boot() {
    each("[data-pdp-buybox]", "BuyBox", initBuyBox);
    each("[data-pdp-cutoff]", "Cutoff", initCutoff);
    each("[data-pdp-offer]", "Offer", initOffer);
    each("[data-pdp-sold]", "Sold", function (el) {
      var textEl = el.querySelector("[data-pdp-sold-text]");
      var count = el.dataset.count;
      if (!textEl || !count) { el.dataset.eligible = "0"; return; }
      textEl.textContent = (el.dataset.template || "{count} sold in the last 30 days")
        .replace("{count}", count);
      el.dataset.eligible = "1";
      capUrgency(el.closest("[data-pdp-urgency]"));
    });
    initCoupons();
    initSizeGuide();
    each("[data-pdp-gallery]", "Gallery", initGallery);
    each("[data-pdp-pin]", "Pin", initPincode);
    each("[data-pdp-xs]", "QuickAdd", initQuickAdd);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", boot);
})();
